<tec-modal [isVisible]="isVisible"
	[title]="'DOCUMENTS.CEA.FORM_TITLE' | translate"
	(closeEvent)="closeModal()">
	<ng-container body>
		<span class="text-align-center" [innerHTML]="'DOCUMENTS.CEA.DESCRIPTION' | translate"></span>
        <div style="align-self: center">
            <pwcs-inline-svg src="assets/images/irpf-cve.svg" idSuffix="modal-irpf-cve-help" />
        </div>
	</ng-container>
</tec-modal>
